import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RootState, useAppSelector } from 'src/redux/store';

export const useAggregationLink = (title?: string): { currentUrl: string | undefined } => {
  const location = useLocation();
  const { t } = useTranslation();
  const enqueteData = useAppSelector((state: RootState) => state.enqueteCreate.enqueteData);
  const formType = enqueteData.surveyDetail?.surveyHeader?.formType;
  let currentUrl: string | undefined;
  // NOTE: SearchModalからの呼び出しは「回答対象組織変更」の時のみリンクを返す
  if (title && title !== t('enqueteCreate.changeRespondentTitle')) {
    return { currentUrl };
  }
  if (formType === 'SERIES') {
    currentUrl = `${window.location.origin}${location.pathname}${location.search}#aggregation`;
  }
  return { currentUrl };
};
